import React from 'react'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import { ParallaxProvider } from 'react-scroll-parallax'

import { theme } from '../theme'
import '../style/reset.css'
import '../style/typography.css'
import 'react-aspect-ratio/aspect-ratio.css'

const GlobalStyle = createGlobalStyle`
  body {
    background: #010101;
    -webkit-font-smoothing: subpixel-antialiased;
    text-rendering: geometricprecision;
    font-family: ${props => props.theme.fonts.sans};
  }
`

const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <>
      <GlobalStyle />
      <ParallaxProvider>{children}</ParallaxProvider>
    </>
  </ThemeProvider>
)

export default Layout
